import React from "react";
import { Link } from "react-router-dom";

const CaseStudyAreaTwo = () => {
  return (
    <>
      {/*================== case-study area start ==================*/}
      <div className='case-study-area pd-top-120'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-5'>
              <div className='section-title text-center'>
                <h2 className='sub-title-sky-blue'>PROJECT GALLERY</h2>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-8 col-md-6'>
              <div className='single-case-study-inner style-2'>
                <div className='thumb'>
                  <img src='assets/img/service/1.png' alt='img' />
                </div>
                <div className='details'>
                  <h5>
                    <Link to='/case-study-details'>Hotel Srinivas</Link>
                  </h5>
                  <a className='cat' href='#'>
                    📍 Mangalore
                  </a>
                </div>
              </div>
              <div className='row'>
                <div className='col-lg-6'>
                  <div className='single-case-study-inner style-2'>
                    <div className='thumb'>
                      <img src='assets/img/service/12.png' alt='img' />
                    </div>
                    <div className='details'>
                      <h5>
                        <Link to='/case-study-details'>MSR Rasta Cafe</Link>
                      </h5>
                      <a className='cat' href='#'>
                        📍 Bengaluru
                      </a>
                    </div>
                  </div>
                </div>
                <div className='col-lg-6'>
                  <div className='single-case-study-inner style-2'>
                    <div className='thumb'>
                      <img src='assets/img/service/13.png' alt='img' />
                    </div>
                    <div className='details'>
                      <h5>
                        <Link to='/case-study-details'>Bunts Sangha College</Link>
                      </h5>
                      <a className='cat' href='#'>
                        📍Mumbai
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* New Images in a Single Row */}
              <div className='row'>
                <div className='col-lg-6'>
                  <div className='single-case-study-inner style-2'>
                    <div className='thumb'>
                      <img src='assets/img/service/16.jpg' alt='img' />
                    </div>
                    <div className='details'>
                      <h5>
                        <Link to='/case-study-details'>Tara Hospital</Link>
                      </h5>
                      <a className='cat' href='#'>
                        📍 Mangalore
                      </a>
                    </div>
                  </div>
                </div>
                <div className='col-lg-6'>
                  <div className='single-case-study-inner style-2'>
                    <div className='thumb'>
                      <img src='assets/img/service/tara1.jpg' alt='img' />
                    </div>
                    <div className='details'>
                      <h5>
                        <Link to='/case-study-details'>Tara Hospital</Link>
                      </h5>
                      <a className='cat' href='#'>
                      📍 Mangalore
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-4 col-md-6'>
              <div className='single-case-study-inner style-2'>
                <div className='thumb'>
                  <img src='assets/img/service/12.1.png' alt='img' />
                </div>
                <div className='details'>
                  <h5>
                    <Link to='/case-study-details'>MSR</Link>
                  </h5>
                  <a className='cat' href='#'>
                    📍Church Street, Bengaluru
                  </a>
                </div>
              </div>
              <div className='single-case-study-inner style-2'>
                <div className='thumb'>
                  <img src='assets/img/service/15.png' alt='img' />
                </div>
                <div className='details'>
                  <h5>
                    <Link to='/case-study-details'>SM Shetty Powai</Link>
                  </h5>
                  <a className='cat' href='#'>
                    📍 Mumbai
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================== case-study area end ==================*/}
    </>
  );
};

export default CaseStudyAreaTwo;
